<template>
    <el-container class="tool-col">
      <el-col class="tool-col" :span="containerSpan">
        <h3 v-if="!!selectedTool" style="padding: 14px;">{{selectedTool?.name}}</h3>
        <iframe v-if="!!selectedTool" style="margin-top: 14px;" focus="true" :src="selectedTool.url" height="100%" width="100%" frameborder="0" />
      </el-col>
      <el-col v-if="handoverExtToolOptions.tools.length > 1" class="tool-col" :span="3">
        <el-menu @select="handleMenuSelect" class="tool-menu" default-active="1" collapse>
          <el-menu-item v-for="(tool, index) in handoverExtToolOptions.tools" :key="index" :index="''+(index+1)">
            <i :class="tool.icon || 'el-icon-d-arrow-left'"></i>
            <span slot="title">{{tool.name}}</span>
          </el-menu-item>
        </el-menu>
      </el-col>
    </el-container>
</template>

<script>
export default {
  name: "ExternalToolView",
  data() {
    return {
      menuIndex: "1",
      selectedTool: null
    }
  },
  mounted() {
    this.selectedTool = this.handoverExtToolOptions.tools[0];
  },
  methods: {
    handleMenuSelect(index) {
      this.menuIndex = index;
      this.selectedTool = this.handoverExtToolOptions.tools[index-1];
    }
  },
  computed: {
    containerSpan() {
      return this.handoverExtToolOptions.tools.length > 1 ? 21 : 24;
    },
    handoverExtToolOptions() {
      return _.get(this, "$store.state.modules.handover.externalTool", {});
    } 
  }
}
</script>

<style scoped>
.tool-col { 
  height: calc(100% - 18px);
}
.tool-menu {
  height: 100%;
  width: 100%!important;
  border-right: 0!important;
  border-left: solid 1px #e6e6e6;
}
</style>
